import { t, tl } from '../i18n/t';

// Ordner unter „Dokumente“ für Dokumente der Kanzlei (dieselbe Liste wie auf dem Server, dokumente/data.ts). Die
// Kanzlei wählt den Ordner beim Hochladen; vorgeschlagen wird er aus dem Titel.
// Bezeichnungen bleiben Deutsch (tl); übersetzt wird beim Anzeigen mit t(label).
export const DOC_FOLDERS = [
  ['vollmachten', tl('Vollmachten')],
  ['vertraege', tl('Verträge')],
  ['bescheinigungen', tl('Bescheinigungen')],
  ['firma', tl('Firmenunterlagen')],
  ['sonstiges', tl('Sonstiges')],
] as const;
export type DocFolder = (typeof DOC_FOLDERS)[number][0];

// Bezeichnung in der gewählten Sprache (Kanzlei: Deutsch)
export const folderLabel = (f: string | null | undefined) => t(DOC_FOLDERS.find(([k]) => k === f)?.[1] ?? 'Sonstiges');

const GUESS: [DocFolder, RegExp][] = [
  ['vollmachten', /vollmacht|sepa|lastschrift/i],
  ['bescheinigungen', /bescheinigung|nachweis|freistellung|unbedenklich/i],
  ['firma', /handelsregister|hr-?auszug|gesellschaftsvertrag|gesellschafterliste|satzung|gewerbe|transparenzregister/i],
  ['vertraege', /vertrag|vereinbarung|auftrag/i],
];
export const guessFolder = (title: string): DocFolder | '' => GUESS.find(([, re]) => re.test(title))?.[0] ?? '';
